import { render, staticRenderFns } from "./OffstreetPermitManagement.vue?vue&type=template&id=f804f9b2&scoped=true"
import script from "./OffstreetPermitManagement.vue?vue&type=script&lang=js"
export * from "./OffstreetPermitManagement.vue?vue&type=script&lang=js"
import style0 from "./OffstreetPermitManagement.vue?vue&type=style&index=0&id=f804f9b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f804f9b2",
  null
  
)

export default component.exports